import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {"header":"styles_header__Hjg1x","close":"styles_close__g8NQY","title":"styles_title__cBmmJ"};
export const b = b_.with('header');